/* eslint-disable */
import { FEATURE_FLAGS_URL } from '../../common';

export const getFeatureFlags =
  async (): Promise<ConfigsApi.FeatureFlagsResponse> => {
    try {
      const response = await fetch(FEATURE_FLAGS_URL);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching feature flags: ', error);
      throw error;
    }
  };

export default getFeatureFlags;